import { getUser } from "./auth";

export const getUserPermissions = (featureName) => {
  const user = getUser();
  const permissions = user?.permissions
  let isAccess = true

  permissions?.map((permission) => {
    if (permission?.featureName == featureName) {
      if (permission?.accessValue == 1) {
        isAccess = false
      }
    }
  })
  return isAccess
}